import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const CampaignEntityItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  isDuplicated: z.boolean(),
});

export const CampaignEntitiesResponseSchema = createResponseSchema(
  CampaignEntityItemSchema,
);

export type CampaignEntityItemType = z.infer<typeof CampaignEntityItemSchema>;
export type CampaignEntitiesResponseType = z.infer<
  typeof CampaignEntitiesResponseSchema
>;
